// File: webelieve-frontend/src/features/admin/components/settings/intake-forms/IntakeFormsPanel.tsx
// EF-6.7: Top-level panel — switches between form list and form builder

import React, { useState } from 'react';
import FormList from './FormList';
import FormBuilder from './FormBuilder';

type Mode = { view: 'list' } | { view: 'builder'; formId: string | null };

const IntakeFormsPanel: React.FC = () => {
  const [mode, setMode] = useState<Mode>({ view: 'list' });

  if (mode.view === 'builder') {
    return (
      <div className="h-[calc(100vh-10rem)]">
        <FormBuilder
          formId={mode.formId}
          onClose={() => setMode({ view: 'list' })}
        />
      </div>
    );
  }

  return (
    <FormList
      onEdit={(formId) => setMode({ view: 'builder', formId })}
      onCreate={() => setMode({ view: 'builder', formId: null })}
    />
  );
};

export default IntakeFormsPanel;
